import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBlockStartPageComponent } from './info-block-start-page/info-block-start-page.component';
import { ButtonModule, BzProductModule } from '../../../modules-ui';
import { SharedModule } from '@shared';
import { TranslocoModule } from '@ngneat/transloco';


@NgModule({
  declarations: [InfoBlockStartPageComponent],
  imports: [
    CommonModule,
    SharedModule,
    BzProductModule,
    ButtonModule,
    TranslocoModule
  ],
  exports:[InfoBlockStartPageComponent]
})
export class EntryComponentsStartPageModule { }
